var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    height: 40,
    width: 143,
    viewBox: "0 0 654.9 183.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#1e91ff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M157 156.4c35.4-35.6 35.4-93.6.1-129.3C139.7 9.6 116.6 0 91.8 0s-48 9.6-65.3 27.1C-.7 54.7-7.7 96.6 9 131.5c2 4.1 6.1 6.7 10.7 6.7 3.2 0 6.2-1.3 8.4-3.5 3.5-3.6 4.5-9 2.3-13.4C17.8 94.9 23.3 63.4 44.2 43 57 30.5 73.9 23.6 91.8 23.6c17.1 0 33.4 6.4 46 17.9 13.8 12.7 21.6 29.9 22 48.6s-6.6 36.2-19.7 49.5c-12.9 13-30 20.1-48.3 20.1-9.8 0-19.6-2.2-28.5-6.2-1.5-.7-3.1-1-4.8-1-3.1 0-6.2 1.3-8.5 3.5-2.8 2.8-4 6.6-3.2 10.5.7 3.9 3.2 7.1 6.9 8.8 11.8 5.4 25 8.2 38.1 8.2 24.7 0 47.8-9.6 65.2-27.1zM65 76.1l26.7-21.2 26.7 21.2v44.1H65V76.1",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M296.9 48.2v26.7h-13.5V49c0-8-4-12.3-11.1-12.3-3.1 0-6.7 1.3-9.8 5.7.3 1.9.5 3.7.5 5.8v26.7h-13.5V49c0-8-4-12.3-11.1-12.3-2.9 0-6.3 1.6-9.3 5.7v32.5h-13.5V25.7H229v3.1c3-2.8 6.3-4.3 12.2-4.3 6.2 0 11.8 2.5 15.8 6.8 5.3-4.7 10.1-6.8 18.2-6.8 12-.1 21.7 9.2 21.7 23.7",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M321.6 45.1H344c-.7-6.3-4.7-9.2-11-9.2-6.7 0-10.2 4-11.4 9.2zm35.8 9.1h-36.1c1 5.7 4.7 10 12.5 10 3.6 0 6.1-.6 7.8-2.8h15c-3.3 9.3-12.1 14.6-22.9 14.6-15.8 0-26.2-11.1-26.2-25.8 0-14.6 10.3-25.9 25.4-25.9 14.3 0 24.9 9.5 24.9 24.1-.1 2.2-.1 3.8-.4 5.8",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M382.4 25.7v49.2h-13.5V25.7h13.5zM367.3 8.1c0-4.6 3.6-8 8.3-8 4.5 0 8.3 3.4 8.3 8 0 4.5-3.7 7.9-8.3 7.9-4.7.1-8.3-3.3-8.3-7.9",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M395.8 74.8h13.5V1.6h-13.5v73.2z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M422.2 74.9h13.5V1.6h-13.5v73.3z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M460.8 44.9h22.4c-.7-6.3-4.7-9.2-11-9.2-6.7.1-10.2 4.1-11.4 9.2zm35.8 9.2h-36.1c1 5.7 4.7 10 12.5 10 3.6 0 6.1-.6 7.8-2.8h15c-3.3 9.3-12.1 14.6-22.9 14.6-15.8 0-26.2-11.1-26.2-25.8 0-14.6 10.3-25.9 25.4-25.9 14.3 0 24.9 9.5 24.9 24.1-.1 2.2-.1 3.8-.4 5.8",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M556.7 25.7v49.2h-13.5V71c-4 3.2-8.7 5.2-14.2 5.2-13.1 0-21.8-9.6-21.8-24V25.7h13.5v25.6c0 8 4 12.6 11.1 12.6 3.7 0 7.8-2.3 11.3-6.5V25.7h13.6",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M602.2 24.7v12.8c-7.6.4-13.2 2.7-17.4 7.4v29.8h-13.5V25.6h13.5v5.7c4.4-4.3 10.1-6.6 17.4-6.6",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M251.8 141.7v-15.6c-3.2-4.5-7.6-5.8-12.1-5.8-7.7 0-13.1 6.2-13.1 13.6 0 7.3 5.4 13.5 13.1 13.5 4.5.1 8.9-1.1 12.1-5.7zm13.5-32.4v49.2h-13.5v-2.8c-3.8 2.5-8.7 4-14.1 4-13.6 0-24.6-11.6-24.6-25.8 0-14.3 10.9-25.9 24.6-25.9 5.5 0 10.3 1.5 14.1 4v-2.8l13.5.1",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M313.9 138.6V126c-3.2-4.6-7.6-6.2-12.1-6.2-7.7 0-13.1 5.2-13.1 13 0 5.8 5.4 12.1 13.1 12.1 4.5-.1 8.9-1.6 12.1-6.3zm13.5-29.3v49.5c0 15.4-10.5 24.7-25.2 24.7-14.1 0-24.7-8.8-25.7-21.1h13.7c.6 5.3 5 8.9 12 8.9 6.6 0 11.7-4.3 11.7-12.4v-6.3c-3.8 2.5-8.7 3.9-14.1 3.9-13.6 0-24.6-11-24.6-23.7 0-14.8 10.9-24.7 24.6-24.7 5.5 0 10.3 1.4 14.1 3.9v-2.7h13.5",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M351.9 128.7h22.4c-.7-6.3-4.7-9.2-11-9.2-6.6.1-10.1 4.1-11.4 9.2zm35.8 9.2h-36.1c1 5.7 4.7 10 12.5 10 3.6 0 6.1-.6 7.8-2.8h15c-3.3 9.3-12.1 14.6-22.9 14.6-15.8 0-26.2-11.1-26.2-25.8 0-14.6 10.3-25.9 25.4-25.9 14.3 0 24.9 9.5 24.9 24.1-.1 2.2-.1 3.8-.4 5.8",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M447.2 131.8v26.7h-13.5v-25.9c0-8-4-12.3-11.1-12.3-3.7 0-7.8 2.2-11.3 6.3v31.9h-13.5v-49.2h13.5v3.7c4-3.2 8.7-5 14.2-5 13.1.1 21.7 9.4 21.7 23.8",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M497.1 157.6c-4.5 1.8-8.3 2.2-11.9 2.2-13.2 0-20.6-8.3-20.6-20.8v-18.3H454v-11.3h10.5V91.5H478v17.8h18.1v11.3H478V139c0 5.8 3.6 8.4 8.7 8.4 3.1 0 6-.9 8.5-2l1.9 12.2",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M528 149.5c5.2 0 8.8-2 8.8-4.8 0-2-1.7-3.6-5.1-4.2l-10.6-1.9c-7.2-1.2-14.5-5.2-14.5-14.4 0-10.1 8.6-16.2 21-16.2 8.9 0 20.6 2.5 21.8 16.6h-12.5c-.3-4.4-4.5-6.4-9.3-6.4-5.2 0-7.6 2.3-7.6 4.6 0 1.9 1.3 4 6.1 4.8l8.9 1.4c7.6 1.3 14.8 4.8 14.8 14.3 0 10.9-9.5 16.3-22 16.3-10.8 0-21.8-4-22.8-18.4l12.5.1c.7 5.8 4.7 8.2 10.5 8.2",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M633.2 65.9c5.2 0 8.8-2 8.8-4.8 0-2-1.6-3.6-5.1-4.2L626.3 55c-7.2-1.2-14.5-5.2-14.5-14.4 0-10.1 8.6-16.2 21-16.2 8.9 0 20.6 2.5 21.8 16.6h-12.5c-.3-4.4-4.5-6.4-9.3-6.4-5.2 0-7.6 2.3-7.6 4.7 0 1.9 1.3 4 6.1 4.8l8.9 1.4c7.6 1.3 14.7 4.8 14.7 14.3 0 10.9-9.5 16.3-22 16.3-10.8 0-21.8-4-22.8-18.4l12.5.1c.8 5.6 4.9 8.1 10.6 8.1",
    className: "st0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.09f38ace9f6d418a25843f42e652581d.svg";
export { ForwardRef as ReactComponent };